module.exports = __webpack_public_path__ + "static/media/awardsbackground.c13d05da.jpg";